
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.667 5.333h4a.667.667 0 00.666-.666v-4A.667.667 0 004.667 0h-4A.667.667 0 000 .667v4c0 .368.299.666.667.666zm6.666 0h4A.666.666 0 0012 4.667v-4A.666.666 0 0011.333 0h-4a.666.666 0 00-.666.667v4c0 .368.298.666.666.666zM.667 12h4a.667.667 0 00.666-.667v-4a.667.667 0 00-.666-.666h-4A.667.667 0 000 7.333v4c0 .368.299.667.667.667zm6.666 0h4a.667.667 0 00.667-.667v-4a.666.666 0 00-.667-.666h-4a.666.666 0 00-.666.666v4c0 .368.298.667.666.667z"}})])
          )
        }
      }
    